import { VideoHTMLAttributes } from 'react'

import { T } from '../../i18n/index.js'
import { useDomain } from '../hooks/useDomain.js'

const handleSubfolder = (src: string, subfolder: string): string => {
  if (src?.indexOf('/') === 0 && src?.indexOf('//') !== 0) {
    return `${subfolder}${src}`
  }

  return src
}

export const Video = ({
  src,
  autoPlay = true,
  loop = true,
  muted = true,
  playsInline = true,
  ...rest
}: VideoHTMLAttributes<HTMLVideoElement>) => {
  const { subfolder } = useDomain()
  const source = handleSubfolder(src, subfolder)

  return (
    <video
      // Force re-render video when source changes to make the browser change to the new source
      key={source}
      src={source}
      autoPlay={autoPlay}
      loop={loop}
      muted={muted}
      playsInline={playsInline}
      {...rest}
    >
      <T
        id="Video.NoBrowserSupport"
        defaultMessage="Sorry, your browser doesn't support embedded videos."
      />
    </video>
  )
}
